module.exports = __webpack_public_path__ + "img/17853_L.123900ca.png";